import React from "react"

const PageButtonsButton = ({ clickAction, children }) => {
  return (
    <button
      className="p-2 fill-dark-sage text-dark-sage bg-gray-200 hover:text-white hover:fill-white hover:bg-ddp-green rounded-md"
      onClick={() => clickAction()}
    >
      {children}
    </button>
  )
}

export default PageButtonsButton
